import {Store} from '@gongxigames/framework/core';
import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';
import {spinButtonStore} from './SpinButtonStore';
import {CoreDI, inject, SlotSettings} from '@gongxigames/framework/slot';
import {CounterData} from '@gongxigames/framework/promotions';

export class SpinButtonService extends UiServiceV2 {
    public static NAME = 'SpinButtonService';

    @inject(CoreDI.Settings)
    protected _settings!: SlotSettings;

    private disabledByStates = Store.signal(false);
    private disabledByIntegration = Store.signal(false);

    onInit(): void {
        this.createEffectBtnDisabled();
        this.createEffectBtnMode();
    }

    onSetupEvents(): void {
        strictUiEmitter.on('UI.playTransitionToFreeSpins', this.onSetFreeSpins.bind(this, true));
        strictUiEmitter.on('UI.playTransitionToMainGame', this.onSetFreeSpins.bind(this, false));
        strictUiEmitter.on('UI.enableSpinAutoMode', this.onSetAutoMode.bind(this, true));
        strictUiEmitter.on('UI.disableSpinAutoMode', this.onSetAutoMode.bind(this, false));

        strictUiEmitter.on('General.enableSpinButton', this.onSetDisabledByStates.bind(this, false));
        strictUiEmitter.on('General.disableSpinButton', this.onSetDisabledByStates.bind(this, true));
        strictUiEmitter.on('Integration.enableSpinButton', this.onSetDisabledByIntegration.bind(this, false));
        strictUiEmitter.on('Integration.disableSpinButton', this.onSetDisabledByIntegration.bind(this, true));

        strictUiEmitter.on('Game.command.quickStopEnable', this.onEnableQuickStopButton.bind(this));
        strictUiEmitter.on('Game.command.skipEnable', this.onSetSkip.bind(this, true));
        strictUiEmitter.on('Game.command.skipDisable', this.onSetSkip.bind(this, false));

        strictUiEmitter.on('General.FreeGames.UpdateCounter', this.onUpdateFGCounter.bind(this));
    }

    private createEffectBtnDisabled() {
        const {disabledByIntegration, disabledByStates, abortSignal} = this;
        const {spinBtn_btnSkipEnabled: btnSkipEnabled, spinBtn_btnDisabled: btnDisabled} = spinButtonStore;

        Store.effect(() => {
            if (disabledByIntegration.value) {
                return btnDisabled.value = true;
            }

            if (btnSkipEnabled.value) {
                return btnDisabled.value = false;
            }

            btnDisabled.value = disabledByStates.value;
        }, {signal: abortSignal});
    }

    private createEffectBtnMode() {
        const {spinBtn_btnMode: btnMode, spinBtn_isAutoPlayActivated: isAutoPlayActivated, spinBtn_isFsActivated: isFsActivated} = spinButtonStore;

        Store.effect(() => {
            if (isFsActivated.value) {
                return btnMode.value = 'free_spins';
            }

            if (isAutoPlayActivated.value) {
                return btnMode.value = 'autoplay';
            }

            btnMode.value = 'base';
        }, {signal: this.abortSignal});
    }

    private onSetDisabledByStates(disabled: boolean) {
        this.disabledByStates.value = disabled;

        if (!disabled) {
            spinButtonStore.spinBtn_btnSkipEnabled.value = false;
        }
    }

    private onSetDisabledByIntegration(disabled: boolean) {
        this.disabledByIntegration.value = disabled;
    }

    private onEnableQuickStopButton() {
        if (this._settings.get('quickStopDisabled')) {
            return;
        }

        this.onSetSkip(true);
    }

    private onSetSkip(enable: boolean) {
        spinButtonStore.spinBtn_btnSkipEnabled.value = enable;
    }

    private onSetAutoMode(enable: boolean) {
        spinButtonStore.spinBtn_isAutoPlayActivated.value = enable;
    }

    private onSetFreeSpins(enable: boolean) {
        spinButtonStore.spinBtn_isFsActivated.value = enable;
    }

    private onUpdateFGCounter({left, total}: CounterData): void {
        spinButtonStore.spinBtn_fsCurrent.value = left;
        spinButtonStore.spinBtn_fsTotal.value = total ?? 0;
    }
}